module.exports = __webpack_public_path__ + "static/media/rocket.840e55c6.png";